import { COMMAND, KEYCODE } from '../utilities/CONSTANTS';
import { isMultilineSelection, textIsSelected } from '../utilities/selectionUtilities';

const customKeyCommands = (e, editorState) => {
    if (e.altKey && e.metaKey) {
        if (e.which === KEYCODE.one) {
            return COMMAND.toggleHeaderOne;
        }

        if (e.which === KEYCODE.two) {
            return COMMAND.toggleHeaderTwo;
        }

        if (e.which === KEYCODE.three) {
            return COMMAND.toggleHeaderThree;
        }
    }

    if (e.metaKey && e.shiftKey) {
        if (e.which === KEYCODE.seven) {
            return COMMAND.toggleOrderedList;
        }

        if (e.which === KEYCODE.eight) {
            return COMMAND.toggleUnorderedList;
        }
    }

    if (e.metaKey && e.which === KEYCODE.e) {
        return COMMAND.toggleInlineFormatHighlight;
    }

    if (e.shiftKey && e.metaKey && e.which === KEYCODE.x) {
        return COMMAND.toggleInlineFormatStrikethrough;
    }

    if (textIsSelected(editorState)) {
        if (e.metaKey && e.which === KEYCODE.k && !isMultilineSelection(editorState)) {
            e.stopPropagation();
            return COMMAND.showLinkDialog;
        }
    }

    return null;
};

export default customKeyCommands;
